<app-load-nav [activeMenuItem]="'sofort'"></app-load-nav>


<mat-card class="content-card">
  <div class="header" fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="10px">
    <div fxLayout="column">
      <div fxLayout="row wrap" fxLayoutGap="10px">
        <button mat-raised-button color="primary" [matMenuTriggerFor]="menu">
          <span>Upload</span>
        </button>
        <mat-menu #menu="matMenu">
          <a mat-menu-item routerLink="transaction-import">
            <mat-icon>add_shopping_cart</mat-icon>
            <span>Upload Sofort Transactions</span>
          </a>
          <a mat-menu-item routerLink="statement-import">
            <mat-icon>assignment_turned_in</mat-icon>
            <span>Upload Statements</span>
          </a>
        </mat-menu>

          <button  mat-raised-button color="accent" [disabled]="table.selection.isEmpty()" (click)="exportSoforts()">Export</button>
      </div>
    </div>
    <div fxLayout="column">
      <div fxLayout="row wrap" fxLayoutGap="10px" *ngIf="table">
        <mat-form-field class="search-field">
          <input #searchField matInput (keydown.enter)="onSearch(searchButton.disabled)" placeholder="Search" [(ngModel)]="table.filters.str">
        </mat-form-field>
        <button #searchButton mat-icon-button (click)="onSearch()">
          <mat-icon>search</mat-icon>
        </button>
        <button mat-icon-button (click)="table.clearFilter()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>
  <app-mat-table-generator #table
    tableName="sofortsTable"
    [useEmbededFilter]="false"
    [columns]="columns"
    [dataSource]="dataSource"
    [editEnabled]="false"
    [deleteEnabled]="false"
    [multiselectEnabled]="true"
    >
  </app-mat-table-generator>
</mat-card>
